// Task 2344 / 2345 - one switch for the Global Diamond + Global Jewelry reports
// (web pages and their Download PDF, which receives these same flags).
//
// GLOBAL_REPORT_PERCENT_ONLY
//   true  = show percentages only, never raw click counts.
//   false = go back to raw counts (the old behaviour) - nothing else to change.
//
// GLOBAL_REPORT_PRIOR_LAST_YEAR
//   true  = "vs prior period" compares with the same dates last year.
//   false = compares with the window right before the selected range (old behaviour).
export const GLOBAL_REPORT_PERCENT_ONLY = true;
export const GLOBAL_REPORT_PRIOR_LAST_YEAR = true;

// Spread into a report config (ReportScaffold / ReportKpiStrip read this).
export const GLOBAL_REPORT_FLAGS = {
  percentOnly: GLOBAL_REPORT_PERCENT_ONLY,
};
